import {svgIconWrapper} from '../svg-icon-wrapper';

import IndustryRegular from './industry-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <IndustryRegular {...validProps} />;
}
SvgComponent.iconName = 'industryRegular';

export const IndustryRegularIcon = svgIconWrapper(SvgComponent);
